import type React from 'react';
import { Outlet } from 'react-router-dom';
import { CheatSheet } from '@/components/shortcuts';

/**
 * Layout route for the seller path — sign-in and the sale screen: mounts
 * `F1`'s cheat sheet beside the matched page, so `F1` opens it only there.
 * Enrollment and the BranchAdmin app sit outside it, and `F1` there is left
 * to the browser. The shortcut provider itself stays at the app root
 * (`App.tsx`).
 */
export const CheatSheetRoute: React.FC = () => (
    <>
        <Outlet />
        <CheatSheet />
    </>
);
